import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOnasfMunicipio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SOBRE A ATUAÇÃO DO NASF NO MUNICÍPIO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Número de equipe do NASF-AB no Município" nome="toesquipenasf" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="7vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>
                    <HeaderVerde texto="NÚMERO DE EQUIPES DE SAÚDE DA FAMÍLIA E ATENÇÃO BÁSICA (ESF/AB) ASSISTIDOS PELO NASF-AB" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Área Urbana" nome="tourbananasf" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="7vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Área Rural" nome="toruralnasf" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="7vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>
                    <HeaderVerde texto="EQUIPE TÉCNICA NA ASSISTÊNCIA" />
                    <CheckContainer>
                        <CheckBox texto="Médico Clínico" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Médico Psiquiatra" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapeuta Ocupacional" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Enfermeiro" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Psicólogo" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Assistente Social" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Técnico de Enfermagem" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Profissional da Educação Física" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Nutricionista" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fonoaudiólogo" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fisioterapeuta" grupo="tosetoresnasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <HeaderVerde texto="TRANSPORTE" />
                    <CheckContainer>
                        <CheckBox texto="Transporte Compartilhado" grupo="totransportenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Transporte Próprio" grupo="totransportenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Não Há Transporte" grupo="totransportenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <HeaderVerde texto="ATIVIDADE DESENVOLVIDA PELOS FISIOTERAPEUTAS DO NASF-AB" />
                    <CheckContainer>
                        <CheckBox texto="Visita Domiciliar" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Apoio Matricial" grupo="toatividadenasf"  modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Atendimento Domiciliar Compartilhado" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Atendimento Individual Compartilhado" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Consulta/Atendimento Compartilhado" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Atividades de Educação em Saúde Coletiva" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Atividades de Educação em Saúde Individual" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Trabalhos com Grupos Temáticos" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Oficinas Multiprofissionais" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Assistência Ambulatorial" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Projeto Terapêutico Singular(PTS)" grupo="toatividadenasf" modulo={modulo} index={n}
                            display="inline-grid" marginR="2vw" />
                        <CheckBox texto="Outros" grupo="toatividadenasf" modulo={modulo} index={n} 
                            display="inline-grid" marginR="2vw" />
                    </CheckContainer>

                </Caixa>
            )
        }
        return partes
    }
}

export default TOnasfMunicipio